import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import Layout from "./Layout";
import Home from "./pages/Home";
import SingleBlog from "./pages/SingleBlog";
import SingleDevNote from "./pages/SingleDevNote"
import About from "./pages/About";
import Contact from "./pages/Contact";
import DevNotePage from './pages/DevNotes';
import ProjectPage from "./pages/Projects";
import MemoryGameOverview from "./pages/ProjectOverview_memory-game";
import NetflixCloneOverview from "./pages/ProjectOverview_netflix-clone";
import BankApplicationOverview from "./pages/ProjectOverview_bank-application";
import hljs from 'highlight.js';
import Page404 from "./pages/Page404";
import { useGlobalContext } from "./context/AppContext";
import "./css/dracula.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';




const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      // Custom breakpoints
      smm: 350,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  palette: {
    mode: 'light',
    primary:{
      main: 'rgb(30, 175, 237)',
    },
    secondary: {
      main: '#000'
    }
  },
  typography: {
    fontFamily: 'Questrial',
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  }
});

function App() {
  const { DarkMode, setDarkMode } = useGlobalContext();

  const toggleMode = ()=>{
    setDarkMode(!DarkMode);
  };
  
  useEffect(()=>{
    hljs.highlightAll();
  }, [DarkMode]);
 

  useEffect(()=>{
    document.getElementsByTagName('body')[0].style.background = `${DarkMode ? '#181818' : '#fff'}`;
  }, [DarkMode]);


  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Layout DarkMode={DarkMode} toggleMode={toggleMode}>
          <Routes>
            <Route path="/" element={<Home DarkMode={DarkMode}/>} />
            <Route path="/learn" element={<DevNotePage DarkMode={DarkMode} />}/>
            <Route path="/projects" element={<ProjectPage DarkMode={DarkMode} />}/>
            <Route path="/reach-out" element={<Contact DarkMode={DarkMode}/>} />
            

            <Route path="/blog/:blog_id"element={<SingleBlog DarkMode={DarkMode} />} />
            <Route path="/dev-note/:devNote_id"element={<SingleDevNote DarkMode={DarkMode} />} />

            <Route path="/project/memory-game" element={<MemoryGameOverview DarkMode={DarkMode}/>} />
            <Route path="/project/netflix-clone" element={<NetflixCloneOverview DarkMode={DarkMode}/>} />
            <Route path="/project/bank-application" element={<BankApplicationOverview DarkMode={DarkMode}/>} />


            <Route path="*" element={<Page404 DarkMode={DarkMode}/>} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
